// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.servicesListContainer .ant-upload.ant-upload-select {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/component/pages/service-provider-admin/modules/services/Services.scss"],"names":[],"mappings":"AAEE;EACE,aAAA;AADJ","sourcesContent":[".servicesListContainer {\n\n  .ant-upload.ant-upload-select {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
